/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The tooltip component for ChartCategory
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.1.0
 */

import { formatBalance } from '../../../../../utils/formatText';
import { IChartTooltipItem, IChartTooltipItemTemplate, IChartTooltipWrapperTemplate } from '../../chartTypes';

export const ChartCategoryTooltipWrapperTemplate = (props: IChartTooltipWrapperTemplate): string => `

    <div class="g2-tooltip chart-category__tooltip" data-component="chartTooltipCategory">

        <!-- TOOLTIP TITLE -->
        <div class="g2-tooltip-title chart-category__title" data-name="tooltipTitle">
            ${props.isHideTooltipDate ? '' :
            `<div class="tooltip__title-date" data-name="titleDate">${props.date}</div>`}
            <div class="tooltip__title-info" data-name="titleInfo">
                <div class="title-info__number" data-name="titleInfoAccount">
                    ${props.mapIdToLabel[props.account]?.title ?? props.account}</div>
                <div class="title-info__city" data-name="titleInfoRegion">
                    ${props.mapIdToLabel[props.account]?.subTitle || ''}
                </div>
            </div>
        </div>

        <!-- TOOLTIP TOTAL INFO -->
        <div class="tooltip__total" data-name="tooltipTotal">
            <span data-name="totalTitle">${props.title}</span>
            <span class="tooltip__total-sum" data-name="totalSum">${formatBalance(props.total)} ${props.currency}</span>
        </div>

        <!-- TOOLTIP ITEMS -->
        <ul class="tooltip__items" data-name="tooltipItems">
            ${props.items.map((item: IChartTooltipItem, index: number) =>
                ChartCategoryTooltipItemTemplate({ item, index, currency: props.currency,
                    mapIdToLabel: props.mapIdToLabel })).join('')}
        </ul>

    </div>
`;

export const ChartCategoryTooltipItemTemplate = (props: IChartTooltipItemTemplate): string =>
    `<li class="tooltip__item" data-index=${props.index} data-name="${props.item.id}">
        <span class="tooltip__item-color" style="background-color:${props.item.color};" data-name="itemColor"> </span>
        <span class="tooltip__item-name" data-name="itemName">${props.item.name}</span>
        <span class="tooltip__item-price" data-name="itemPrice">
            ${formatBalance(props.item.value)} ${props.currency}</span>
    </li>`;

